import React from "react";
import { datadogRum } from "@datadog/browser-rum";
import { createRoot } from "react-dom/client";

import App from "./App";
import { getConfig } from "./config";

interface InitErrorReportingArgs {
	name: string;
	version: string;
	env: string;
	ddToken: string;
	ddAppId: string;
}

export const initErrorReporting = ({
	name,
	version,
	env,
	ddToken,
	ddAppId,
}: InitErrorReportingArgs) => {
	// Setup Datadog RUM functionality
	datadogRum.init({
		clientToken: ddToken,
		site: "datadoghq.com",
		service: name,
		env,
		telemetrySampleRate: 100, // %
		trackSessionAcrossSubdomains: true,
		version,
		applicationId: ddAppId,
	});
};

if (process.env.NODE_ENV === "production") {
	initErrorReporting({
		name: getConfig("name"),
		version: getConfig("version"),
		env: getConfig("env"),
		ddToken: getConfig("datadogrumclienttoken"),
		ddAppId: getConfig("datadogrumapplicationid"),
	});
}

if (getConfig("mswenabled")) {
	import("merchant-portal-data/worker.mock").then(({ worker }) => {
		worker.start({ onUnhandledRequest: "bypass" });
	});
}

const rootElement = document.createElement("div");
document.body.appendChild(rootElement);
const root = createRoot(rootElement);

root.render(<App />);
